import React, { Component } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { DropdownProps, Grid, Header, Radio } from 'semantic-ui-react';
import { Field } from 'react-final-form';
import Input from 'components/final-form/Input';
import Select from 'components/final-form/Select';
import TextArea from 'components/final-form/TextArea';
import { ensureOnlyNumericInput } from 'utils/filterUtils';
import PraxFormGrid from 'components/layout/PraxFormGrid';
import { Views } from 'components/costestimation/UpsertCostEstimation';

interface Props extends MessageSourceProps {
  visibleView: Views,
  onAddressRadioChange: (selectedView: Views) => void,
  guarantors: Array<DropdownProps>
}

class BillOptionSegment extends Component<Props> {

  constructor(props: Props) {
    super(props);
  }

  getSegmentByView = (): React.ReactNode | undefined => {

    const {visibleView} = this.props;

    switch (visibleView) {
      case Views.GUARANTORS: {
        return this.renderGuarantorsSegment();
      }
      case Views.SPECIAL: {
        return this.renderSpecialAddressSegment();
      }
    }

    return;
  };

  render(): React.ReactNode {

    const {visibleView, onAddressRadioChange, getMessage} = this.props;

    return (
        <PraxFormGrid>
          <Grid.Row>
            <Grid.Column>
              <Header>{getMessage("costEstimation.billOptions")}</Header>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3} verticalAlign="middle">
              {getMessage("surchargeDiscount")}:
            </Grid.Column>
            <Grid.Column width={5} verticalAlign="middle">
              <Field
                  name="discount"
                  component={Input}
                  onKeyDown={ensureOnlyNumericInput}
                  icon="percent"
                  fluid
              />
            </Grid.Column>
            <Grid.Column width={3} verticalAlign="middle">
              {getMessage("costEstimation.installment")}:
            </Grid.Column>
            <Grid.Column width={5} verticalAlign="middle">
              <Field
                  name="advance"
                  component={Input}
                  onKeyDown={ensureOnlyNumericInput}
                  fluid
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}>
              {getMessage("address")}:
            </Grid.Column>
            <Grid.Column width={3}>
              <Radio
                  onClick={() => onAddressRadioChange(Views.NONE)}
                  checked={visibleView === Views.NONE}
                  label={getMessage("patient")}
                  name="address"
              />
            </Grid.Column>
            <Grid.Column width={3}>
              <Radio
                  onClick={() => onAddressRadioChange(Views.GUARANTORS)}
                  checked={visibleView === Views.GUARANTORS}
                  label={getMessage("guarantor")}
                  name="address"
              />
            </Grid.Column>
            <Grid.Column width={3}>
              <Radio
                  onClick={() => onAddressRadioChange(Views.SPECIAL)}
                  checked={visibleView === Views.SPECIAL}
                  label={getMessage("special")}
                  name="address"
              />
            </Grid.Column>
          </Grid.Row>
          {this.getSegmentByView()}
        </PraxFormGrid>
    );
  };

  renderGuarantorsSegment = (): React.ReactNode => {

    const {guarantors, getMessage} = this.props;

    return (
        <Grid.Row>
          <Grid.Column width={3} verticalAlign="middle">
            {getMessage("guarantor")}:
          </Grid.Column>
          <Grid.Column width={13} verticalAlign="middle">
            <Field
                name="guarantorId"
                component={Select}
                options={guarantors}
                fluid
            />
          </Grid.Column>
        </Grid.Row>
    )
  };

  renderSpecialAddressSegment = (): React.ReactNode => {

    const {getMessage} = this.props;

    return (
        <Grid.Row>
          <Grid.Column verticalAlign="middle">
            <Field
                name="specialAddress"
                component={TextArea}
                placeholder={getMessage("specialAddress")}
                style={{minHeight: "100px", maxHeight: "100px"}}
            />
          </Grid.Column>
        </Grid.Row>
    )
  }
}

export default withMessages(BillOptionSegment);
